import React, { EventHandler } from "react";

interface IHelpDropdown {
  isLoggedIn: boolean;
  chatLoaded: boolean;
}

const HelpDropdown = ({ isLoggedIn, chatLoaded }: IHelpDropdown) => {
  const help = document.getElementById('shopify-section-support')
  const executeScroll = (e: React.MouseEvent<HTMLButtonElement> | undefined): void => { e?.preventDefault(); help?.scrollIntoView(); }
  {/* @ts-ignore */}
  const chatClick = (e: React.MouseEvent<HTMLButtonElement> | undefined): void => { e?.preventDefault(); $zopim.livechat.window.show()}

  return (
      <ul className="dropBox flex flex-col absolute bg-white w-[140px] py-10 top-[100%] z-1000">
          <li className="h-40 flex flex-col justify-center items-start px-15">
            {chatLoaded && (
              <button onClick={chatClick} aria-label='chat' className="text-[12px] text-grey-600">
                Chat
              </button>
            )}
            {!chatLoaded && (
              <p aria-label='chat offline' className="text-[12px] text-grey-600 tracking-normal">
                Chat Offline
              </p>
            )}
          </li>

          <li className="h-40 flex flex-col justify-center items-start px-15">
            <button onClick={executeScroll} aria-label='email' className="text-[12px] text-grey-600">
              Email
            </button>
          </li>

          <li className="h-40 flex flex-col justify-center items-start px-15">
            <button onClick={executeScroll} aria-label='phone' className="text-[12px] text-grey-600">
              Phone
            </button>
          </li>

          {isLoggedIn && (
            <li className="h-40 flex flex-col justify-center items-start px-15">
              <a href="/pages/order-history" aria-label='track your order' className="text-[12px] text-grey-600 tracking-normal">
                Track Your Order
              </a>
            </li>
          )}
      </ul>
    )
};

export default HelpDropdown;
